//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "alliance_personal",
    data() {
        return {
            title: "个人信息",
            selectSex: 0, //默认性别
            user: "", //个人信息
            pets: [], //宠物列表
            age: "",
            userName: "",
            isReadonly: true,
            url: window.location.href //当前地址
        };
    },
    watch: {
        userName: function() {
            if (this.userName == "") {
                this.isReadonly = true;
            }
        }
    },
    created() {
        if (sessionStorage.getItem("token") == null) {
            this.get_token(this.url);
        } else {
            this.get_users();
        }
    },
    methods: {
        //获取token
        get_token(url) {
            var self = this;
            this.$EpetJs.Common.approve(url, function() {
                self.get_users();
            }); //生成token
        },
        //修改用户名称
        save(name) {
            var self = this;
            var urlValue = self.$EpetJs.Helper.createApiUrl("public/user");
            if (name == "") {
                self.$vux.toast.text("请输入姓名");
                return false;
            }
            self.$EpetJs.Helper.ajaxRequest(
                urlValue,
                { name: name },
                "patch"
            ).then(({ data }) => {
                if (data.status_code == 200) {
                    self.$vux.toast.text("修改成功");
                    self.isReadonly = true;
                } else {
                    self.$vux.toast.text(data.message);
                }
            });
        },
        //修改性别
        changeSex(sex) {
            var self = this;
            var urlValue = self.$EpetJs.Helper.createApiUrl("public/user");
            self.$EpetJs.Helper.ajaxRequest(
                urlValue,
                { gender: sex },
                "patch"
            ).then(({ data }) => {
                if (data.status_code == 200) {
                    self.selectSex = data.data.gender;
                } else {
                    self.$vux.toast.text(data.message);
                }
            });
        },

        //计算月份
        get_birth(birth) {
            //birth:生日 秒数
            var now = new Date();
            var days = now.getTime() / 1000 - birth;
            var month = parseInt(days / (60 * 60 * 24) / 30);
            // console.log(month,6666)
            return month;
        },
        //获取个人资料
        get_users() {
            var self = this;
            this.$EpetJs.Common.get("public/user/detail", {}).then(
                ({ data }) => {
                    if (data.status_code == "200") {
                        self.user = data.data;
                        self.userName = data.data.name;
                        if (data.data.name && data.data.name != "") {
                        } else if (data.data.name && data.data.name == "") {
                            self.isReadonly = true;
                        }
                        self.pets = data.data.pets;
                        if (data.data.gender == 1) {
                            self.selectSex = 1;
                        } else if (data.data.gender == 2) {
                            self.selectSex = 2;
                        } else if (data.data.gender == 0) {
                            self.selectSex = 0;
                        }
                    }
                }
            );
        },
        update() {
            this.isReadonly = false;
        },
        //删除宠物
        delete_pet(pid) {
            var self = this;
            this.$vux.confirm.show({
                content: "确定删除该宠物吗？",
                onCancel() {},
                onConfirm() {
                    var urlValue = self.$EpetJs.Helper.createApiUrl(
                        "public/user/pets/" + pid
                    );
                    self.$EpetJs.Helper.ajaxRequest(
                        urlValue,
                        {},
                        "delete"
                    ).then(({ data }) => {
                        if (data.status_code == 200) {
                            self.$vux.toast.text("删除成功");
                            self.get_users();
                        } else {
                            self.$vux.toast.text(data.message);
                        }
                    });
                }
            });
        },
        //跳转宠物信息页面
        go_pet(pid) {
            this.$router.push({
                name: "alliance_petinfo",
                query: { pid: pid }
            });
        },
        //跳转绑定页
        go_bind() {
            this.$router.push({ name: "alliance_bindphone", judge: 2 });
        }
    }
};
